import React, {useEffect, useState, useRef} from 'react'
import {Breadcrumb, Layout, PageHeader, Button, message, Popconfirm, Table, Input, Row, Col, Space, Tag} from 'antd'
import { PlusOutlined, UserOutlined, LeftOutlined, RightOutlined, StopOutlined } from '@ant-design/icons';
import {useHistory} from 'react-router-dom'
import { firestore, functions } from '../../firebase'
import {debounce} from '../../shared/utilities'
import { useRecoilState } from 'recoil'
import { userState } from '../../atoms'




const deleteUser = functions.httpsCallable('deleteUser');

function ListUsers() {
  
  const {Content} = Layout;
  const { Search } = Input;
  const history = useHistory();
  const resultsPerPage = 20;
    
  //state
  const [ data, setData] = useState([]);
  const [ loading, setLoading] = useState(false);
  const [ searchText, setSearchText] = useState('');
  const [ tableParams, setTableParams] = useState({});
  const [ lastDocRef, setLastDocRef] = useState(null);
  const [ firstDocRef, setFirstDocRef] = useState(null);
  const [ prevDisabled, setPrevDisabled] = useState(true);
  const [ nextDisabled, setNextDisabled] = useState(false);
  const [ currentPage, setCurrentPage] = useState(1);
  const [ totalItems, setTotalItems] = useState(null);
  const [currentUser, setCurrentUser] = useRecoilState(userState);
  

  let unsubscribeFromTotalItems = null;

    
  const onCellClick = (record) => {
    return {
      onClick: event => { history.push({
        pathname: `/users/${record.id}`,
        state: record
      })}
    }
  }

  const fetch = async (params = {}, searchTextToUse = null, movePage = null) => {
      
    if (searchTextToUse) {
      searchTextToUse = searchTextToUse.toLowerCase();
    }
    
    setTableParams(params);
    let sortField = params.sortField ? params.sortField : "first_name";
    setLoading(true);
    
    try {
      
      let startAfter = '';
      //let limit = 10;
      if (movePage === "next") {
        startAfter = lastDocRef;
      }

      let query = firestore.collection("users").orderBy(sortField).limit(resultsPerPage);

      if (currentUser.role !== 'admin') {
        query = query.where('team_id','==',currentUser.team_id)
      }

      if (searchTextToUse) {
        query = query.where('search_fields', 'array-contains', searchTextToUse);
      }

      if (movePage === "next" || !movePage) {
        //Moving to next page or getting first page
          if (startAfter) {
            query = query.startAfter(startAfter);
          }
      } else {
        //Moving to Previous Page
          query = query.endBefore(firstDocRef).limitToLast(resultsPerPage)
      }

      let refs = await query.get();
      
      let results = [];
      setLastDocRef(refs.docs[refs.docs.length -1]);
      setFirstDocRef(refs.docs[0]);
     
      refs.forEach(function(doc) {
       
          results.push({id: doc.id, ...doc.data()})
        
        
      });
        
      setData(results);
      
      if (results.length < resultsPerPage) {
        setNextDisabled(true);
      } else {
        setNextDisabled(false);
      }

      if ((currentPage+1)*resultsPerPage === totalItems) {
        setNextDisabled(true);
      }

      if (movePage === 'next') {
        setPrevDisabled(false);
        setCurrentPage(prevCurrentPage => prevCurrentPage + 1 );
      }

      if (movePage === 'previous') {
        if (currentPage === 2) {
          setPrevDisabled(true);
        }
        setNextDisabled(false);
        setCurrentPage(prevCurrentPage => prevCurrentPage - 1 );
      }
     
      setLoading(false);

    } catch(error) {
      console.log("Error getting documents: ", error);
    }
  };

  const { current: fetchItems } = useRef(fetch);

  const subscribeTototalItems = () => {
    unsubscribeFromTotalItems = firestore.doc("counters/users").onSnapshot((doc) => {
      if (doc.data()) {
        console.log("Total Users",doc.data().count);
        setTotalItems(doc.data().count);
      }
      
    })
    
  }

  const { current: sub } = useRef(subscribeTototalItems);
  //const { current: unsub } = useRef(unsubscribeFromtotalItems);
  
  useEffect(() => {
      sub();
     
      fetchItems();
      return () => {
        unsubscribeFromTotalItems();
      }

    
  },[sub,fetchItems])


  let columns = [
    
    {
      title: 'Name',
      render: (text, record) => {return record.first_name + " " + record.last_name},
      //width: '30%',
      onCell: (record) => onCellClick(record),
      className: "item-cell"
    },
    {
      title: 'Email',
      dataIndex: 'email',
      //width: '20%',
      onCell: (record) => onCellClick(record),
      className: "item-cell"
    },
    
    {
      title: 'Group',
      dataIndex: 'group_name',
      //width: '20%',
      onCell: (record) => onCellClick(record),
      className: "item-cell"
    },
    {
      title: 'Role',
      dataIndex: 'role',
      
      //width: '10%',
      onCell: (record) => onCellClick(record),
      className: "item-cell"
      
    },
    {
      title: 'Status',
      render: (text, record) => {
        
        if (record.disabled) {
         return <Tag icon={<StopOutlined />} color="error">disabled</Tag>;
        } 
        return null;
      },
      onCell: (record) => onCellClick(record),
      className: "item-cell"
    },
    
    {
      title: 'Action',
      
      
      render: (text, record) => {
        return (
          <Popconfirm
            title={"Delete User: " + record.first_name + " " + record.last_name + "?"}
            onConfirm={() => deleteEntry(record.id)}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <a href="#">Delete</a>
          </Popconfirm>
        )
      }
    }
  ];

  if (currentUser.role === 'admin') {
    columns.splice(2,0,{
      title: 'Team',
      dataIndex: 'team_name',
      //width: '20%',
      onCell: (record) => onCellClick(record),
      className: "item-cell"
    },)
  }

  

    const deleteEntry = (id) => {
      setLoading(true);
      deleteUser(id)
            .then(function(resp) {
              //Display success
              console.log(resp.data.result);
              message.success('Deleted User');
              fetch();
              
            })
            .catch(function(error) {
              const code = error.code;
              const message = error.message;
              console.log(code,message);
              message.error(message);
              setLoading(false);
              //Display error
            }); 
      
     
    }
    
    const cancel = (e) => {
      console.log(e);
      
    }

    const handleTableChange = (pag, filters, sorter) => {
      //const pager = { ...pagination };
      //pager.current = pag.current;
      setCurrentPage(1);
      setPrevDisabled(true);
      //setPagination({...pager},
        fetch({
          results: pag.pageSize,
          page: pag.current,
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...filters,
          
        })
        
      //  );
      
      
      
    };

    
  
    

    const onTextSearch = debounce((value) => {
           console.log("onKeystroke",value);
           setCurrentPage(1);
           setPrevDisabled(true);
           setSearchText(value, setCurrentPage(1,fetch(tableParams,value)) );
           //fetch(tableParams,value);
    },250)
  


    return (
        <div>
          <Breadcrumb>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>Users</Breadcrumb.Item>
            
          </Breadcrumb>
       
        
          <Content className="site-layout-background">
          
       
            <PageHeader
            className="site-page-header-responsive"
            avatar={{icon: <UserOutlined />}}
            ghost={false}
            onBack={() => window.history.back()}
            title="Users"
            
            backIcon={false} 
            extra={[
               
              <Row gutter={[8,8]} key="extra_row">
                <Col lg={14} sm={24} key="search">
                    <Search
                    placeholder="search by name"
                    block="true"
                    //style={{ width: 200 }}
                    key="search"
                    onChange={(e) => onTextSearch(e.target.value)}
                  />
                </Col>
                <Col lg={10} sm={24} key="create_new">
                  <Button key="/" type="primary" block="true" onClick={() => {history.push("/users/new")}}>
                  <PlusOutlined />Create New
                  </Button>
                </Col>
              </Row>
              
            ]}
            >
            
            </PageHeader>

            <Table
              columns={columns}
              className="ant-table"
              //scroll={{x: 'calc(100vh - 4em)'}}
              scroll={{ x: 'max-content' }}
              rowKey={record => record.id}
              sortDirections={['ascend']}
              dataSource={data}
              pagination={false}
              loading={loading}
              onChange={handleTableChange}
              size="small"
              
            />
            <Row gutter={[8,8]} align="middle" justify="end" style={{marginTop: '16px'}} >
              <Col >
                <span>
                  { (searchText || currentUser.role !== 'admin') ? null : (currentPage-1)*resultsPerPage+1 + " to " + (totalItems < currentPage*resultsPerPage ? totalItems : currentPage*resultsPerPage ) + " of " + totalItems + " Total Entries"}
                </span>
              </Col>
              <Col >
                <Space>
                  <Button disabled={prevDisabled} key="previous" type="default" onClick={() => fetch(tableParams, searchText, "previous")}>
                      <LeftOutlined />Previous
                    </Button>
                  
                  <Button disabled={nextDisabled} key="next" type="default" onClick={() => fetch(tableParams, searchText, "next")}>
                      <RightOutlined />Next
                    </Button>
                </Space>
              </Col> 
                
                
              
            </Row>

        </Content>
            
        </div>
    )
}

export default ListUsers
